export const RECEPTACLE_SEARCH_FORM_DATA = 'receptacle_search_form_data';
